import React, { useEffect, useState } from "react";
import Style from '../LeftNavigation.module.css';
import Hourglass from '../../../../assets/svg/Hourglass.svg';
import Shield from '../../../../assets/svg/Shield.svg';
import Person from '../../../../assets/svg/Person.svg';

const Tab = (props) => {
    const { item, index, isActive, setActiveTab } = props;

    const handleTab = () => {
        setActiveTab(item.id);
    };

    return (
        <div className={`${isActive ? Style.active : item.cssClass}`} onClick={handleTab} key={index}>
            {isActive && <span />}
            <img src={item.logo} alt="" />
            <p className="mb-0 text-xsm-400 gray-light-black">{item.label}</p>
        </div>
    );
}

export default Tab;